import * as React from "react";
import { BottomForm } from "../HeroScreen/BottomForm";
import AvailableInCountry from "./AvailableInCountry";

export const ExchangeContent = () => (
  <div className="exchange__content">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 light">
          <div className="exchange__text">
            <h1 className="exchange__title title">
              Buy Coins <br /> Fast With Credit Cards And Bank Transfer
            </h1>
            <p className="exchange__slogan slogan">
              Get the access to the crypto markets in a couple of seconds with absolutely zero delay!
            </p>
            <div className="d-lg-inline-block d-none">
              <AvailableInCountry />
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <BottomForm />

          <div className="d-lg-none d-inline-block" style={{ marginTop: "12px", alignItems: "center" }}>
            <AvailableInCountry />
          </div>
        </div>
      </div>
    </div>
  </div>
);
